import { useState } from "react";
import TimeStamp from "./TimeStamp";
import IsOnline from "./IsOnline";
import DetailsUser from "./DetailsUser";
import PrintPage from "./PrintPage"
import EditUser from "./EditUser";
import UserActions from "./UserActions";
import DeleteUser from "../Modal/DeleteUser";

function RowUser({ item, index, onSelect, isSelected, openError, openSuccess, onDeleted }) {
    const [openModal, setOpenModal] = useState(null); // 'details' | 'print' | 'edit' | 'delete'

    const handleChecked = (checked) => onSelect(item.id, checked);

    const rowBg = isSelected
        ? "bg-blue-200"
        : index % 2
            ? "bg-primary-100 hover:bg-slate-100"
            : "bg-white hover:bg-slate-100";


    return (
        <>
            <div className={`flex flex-row-reverse items-center text-right p-2 text-sm ${rowBg}`}>
                <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={(e) => handleChecked(e.target.checked)}
                    className="ml-2 w-8 h-4 cursor-pointer"
                />
                <p className="w-64">{item.name}</p>
                <p className="w-52">{item.id}</p>
                {/* <p className="w-44">{item.userType}</p> */}
                {/* <p className="w-52">{item.nickName} {item.familyName}</p> */}
                <p className="w-52">{item.phoneNumber}</p>
                <p
                    className={`w-52 ${!item.ip ? "text-gray-400" : "text-black"}`}
                >
                    {item.ip || "-"}
                </p>                {/* <div className="w-32"><IsOnline isOnline={item.isOnline} /></div> */}
                <div className="w-52 text-xs"><TimeStamp timestamp={item.createdTime} /></div>
                <div className="w-52 text-xs"><TimeStamp timestamp={item.updatedTime} /></div>
                <UserActions onOpen={setOpenModal} />
            </div>

            {openModal === "details" && <DetailsUser user={item} close={() => setOpenModal(null)} />}
            {openModal === "print" && <PrintPage organization={item.name} token={item.token} close={() => setOpenModal(null)} />}
            {openModal === "edit" && <EditUser user={item} close={() => setOpenModal(null)} openError={openError} openSuccess={openSuccess} />}
            {openModal === "delete" && <DeleteUser user={item} close={() => setOpenModal(null)} openError={openError} openSuccess={openSuccess} onDeleted={onDeleted} />}
        </>
    );
}
export default RowUser;